import { PartnerCenterSeller } from "../models/entities";

export const sellerHasGdkSwRole = (seller: PartnerCenterSeller): boolean =>
  seller.roles?.includes("Dev-Game-Platform-GDK_SW") ?? false;
